<template>

    <AppLayout :title="title">

        <div class="flex bg-white items-center p-4 sm:p-8 rounded-lg mb-8">

            <div class="flex flex-col  sm:mr-24">

                <h2 class="text-xl md:text-3xl font-nexa text-blue mb-4 ">{{ name }}</h2>

                <p class=" md:text-lg leading-normal opacity-40" v-html="description"></p>

            </div>

            <div class="hidden sm:inline flex justify-center items-center ml-auto">

                <img class="w-16" :src="icon_url" :alt="name" />

            </div>

        </div>


        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-6">

            <div v-for="exercise of exercises"
                :key="exercise.id"
                class="flex flex-row sm:flex-col rounded-md sm:rounded-lg bg-white h-[100px] sm:h-[380px]">


                <div class="flex w-14 sm:w-full sm:h-[250px]">

                    <Link class="text-black text-lg font-bold mb-2 w-full h-full"
                          :href="route('exercise', exercise.slug)">

                        <div class="w-14 sm:w-full h-full rounded-l-md sm:rounded-bl-none sm:rounded-t-lg bg-center bg-no-repeat bg-cover"
                            :style="`background-image: url('${ exercise.thumbnail_url }');`">
                        </div>

                    </Link>

                </div>


                <div class="flex flex-col w-full p-1 pl-3 sm:p-5 sm:h-[130px] ">

                    <Link class="flex flex-col w-full text-black text-lg font-bold cursor-pointer"
                          :href="route('exercise', exercise.slug)">

                        <h3 class="text-black sm:break-normal text-sm sm:text-lg sm:font-bold mb-2 leading-normal sm:leading-6">{{ exercise.name }}</h3>

                    </Link>


                    <p class="hidden sm:inline mb-6 cursor-pointer"
                        v-if="exercise.description && exercise.description !== ' '"
                        @click="$inertia.visit(route('exercise', exercise.slug))">

                        {{ excerpt(exercise.description) }}

                    </p>


                    <div class="flex flex-row cursor-pointer mt-auto mb-1"
                        :class="{
                            'remove_favorite_button': exercise.active,
                            'add_favorite_button': ! exercise.active
                        }"
                        @click="handle_click_exercise_for_user_favorit(exercise)">

                        <font-awesome-icon
                            id="active_icon"
                            :icon="['fas', 'heart']"
                            class="text-xs sm:text-lg mr-2 text-red"
                            :class="{
                                'hidden': ! exercise.active
                            }"
                        ></font-awesome-icon>

                        <font-awesome-icon
                            id="deactive_icon"
                            :icon="['far', 'heart']"
                            class="text-xs sm:text-lg text-blue mr-2"
                            :class="{
                            'hidden': exercise.active
                            }"
                        ></font-awesome-icon>

                        <p v-if="exercise.active"
                           class="text-sm text-black text-opacity-40 select-none">{{ __('Remove from favorites') }}</p>

                        <p v-else
                           class="text-sm text-black text-opacity-40 select-none">{{ __('Add to favorites') }}</p>

                    </div>

                </div>

            </div>

        </div>


    </AppLayout>

</template>

<script>
import {defineComponent} from 'vue';
import AppLayout from "@/Layouts/AppLayout";
import { Link } from '@inertiajs/inertia-vue3';

export default defineComponent({

    name: "ExerciseCategory",

    props: {
        slug: String,
        name: String,
        description: String,
        icon_url: String,
        exercises: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        slug: 'shoulder-exercise-1',
                        name: 'Shoulder exercise 1',
                        description: 'Shoulder exercise number 1 description. Lorem ipsum dolor sit amet, consectetur adipiscin. dolor sit amet, consectetur adipiscing elit. ',
                        active: true,
                    },
                    {
                        id: 2,
                        slug: 'shoulder-exercise-2',
                        name: 'Shoulder exercise 2',
                        description: 'Shoulder exercise number 2 description. Lorem ipsum dolor sit amet, consectetur adipiscin. dolor sit amet, consectetur adipiscing elit. ',
                        active: false,
                    },
                ]
            }
        },
    },

    components: {
        AppLayout,
        Link
    },

    computed: {

        title() {

            return this.__(`:name Exercises`, {
                name: this.name
            });

        }

    },

    methods: {

        excerpt(string) {

            // return string.substring(
            //     0,
            //     string.indexOf('. ') + 1
            // );

            return _.truncate(
                string,
                {
                    length: 150,
                    omission: '...'
                }
            )

        },


        handle_click_exercise_for_user_favorit(exercise) {                      let debug_id = Debug.init_method('handle_click_exercise_for_user_favorit',false);

            let
                route = this.route('exercise_user_favorite_toggle', {
                    exercise: exercise.slug
                })
            ;                                                                   Debug.log(debug_id,249,{route});


            this.$inertia
                .patch( route, {
                    preserveScroll: true,
                    onSuccess: this.reload_page,
                });

        },


        reload_page() {

            this.$inertia.reload({
                only: ['exercises']
            });

        }

    }

});
</script>

<style scoped>

.remove_favorite_button:hover #active_icon {
    display: none;
}

.remove_favorite_button:hover #deactive_icon {
    display: block;
}

.add_favorite_button:hover #active_icon {
    display: block;
}

.add_favorite_button:hover #deactive_icon {
    display: none;
}


</style>
